export default Alpine.magic('clipboard', () => subject => {
    navigator.clipboard.writeText(subject)
})
